__turbopack_context__.v({
  "root": "checkout-module__kUatKa__root",
  "shippingLabelFadeIn": "checkout-module__kUatKa__shippingLabelFadeIn",
});
